import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function isApp() {
  // Only return true if running inside a native Capacitor/Cordova app
  return (
    typeof window !== 'undefined' &&
    (
      (window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform()) ||
      window.cordova
    )
  );
}

function HomePage() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const handlePlaystore = () => {
    alert("Feature coming soon");
  };
  const handleVisitWebsite = () => {
    window.open("https://tradespot.online", "_blank");
  };

  return (
    <div
      style={{
        margin: 0,
        fontFamily: "'Segoe UI', sans-serif",
        background: "linear-gradient(135deg, #0a1e40, #003366)",
        color: "#ffffff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px",
        minHeight: "100vh",
        boxSizing: "border-box",
      }}
    >
      <header
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "15px 20px",
          background: "linear-gradient(135deg, #0a1e40, #003366)",
          boxShadow: "0 2px 6px rgba(0, 0, 50, 0.3)",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            fontSize: "26px",
            fontWeight: "bold",
            color: "#00bfff",
            marginBottom: "10px",
          }}
        >
          TradeSpot
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <button
            onClick={() => navigate("/login")}
            style={{
              padding: "10px 16px",
              background: "linear-gradient(90deg, #00bfff, #0056b3)",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontWeight: "bold",
              cursor: "pointer",
              transition: "background 0.3s, transform 0.2s",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
              width: "100%",
              maxWidth: "300px",
            }}
          >
            Login
          </button>
          <button
            onClick={() => navigate("/signup")}
            style={{
              padding: "10px 16px",
              background: "linear-gradient(90deg, #00bfff, #0056b3)",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontWeight: "bold",
              cursor: "pointer",
              transition: "background 0.3s, transform 0.2s",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
              width: "100%",
              maxWidth: "300px",
            }}
          >
            Sign Up
          </button>
          <button
            onClick={() => {
              if (localStorage.getItem("authToken")) {
                navigate("/dashboard");
              } else {
                alert("Please log in to access the dashboard");
                navigate("/login");
              }
            }}
            style={{
              padding: "10px 16px",
              background: "linear-gradient(90deg, #00bfff, #0056b3)",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontWeight: "bold",
              cursor: "pointer",
              transition: "background 0.3s, transform 0.2s",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
              width: "100%",
              maxWidth: "300px",
            }}
          >
            Dashboard
          </button>
          {/* Removed Social Hub button */}
          {isApp() ? (
            <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
              <button
                onClick={handleVisitWebsite}
                style={{
              padding: "10px 16px",
              background: "linear-gradient(90deg, #00bfff, #0056b3)",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontWeight: "bold",
              cursor: "pointer",
              transition: "background 0.3s, transform 0.2s",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
              width: "100%",
              maxWidth: "300px",
            }}
              >
                Visit Website
              </button>
            </div>
          ) : (
            <button
              onClick={() => setShowModal(true)}
              style={{
                padding: "10px 16px",
                background: "linear-gradient(90deg, #00bfff, #0056b3)",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                fontWeight: "bold",
                cursor: "pointer",
                transition: "background 0.3s, transform 0.2s",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                width: "100%",
                maxWidth: "300px",
              }}
            >
              Download App
            </button>
          )}
        </div>
      </header>
      <main
        style={{
          textAlign: "center",
          marginTop: "20px",
          maxWidth: "90%",
          background: "#fff",
          color: "#333",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            fontSize: "20px", // Smaller and more concrete
            fontWeight: 700,
            marginBottom: "20px",
            color: "#003366",
            fontFamily: "'Segoe UI Semibold', 'Segoe UI', Arial, sans-serif",
            letterSpacing: "0.5px"
          }}
        >
          TradeSpot – Redefining Crypto Investment Through Trust, Innovation, and Automation
        </div>
        <div
          style={{
            fontSize: "14px",
            lineHeight: "1.5",
            marginBottom: "20px",
            textAlign: "left",
          }}
        >
          <span>
            TradeSpot is a full-scale digital investment infrastructure designed to bridge the gap between traditional wealth management and the decentralized future of finance. Built from the ground up with a focus on transparency, automation, and user trust, TradeSpot empowers individuals to invest in crypto markets effortlessly while our in-house trading systems and proprietary AI technologies handle the complexities of the market.<br /><br />
            At its core, TradeSpot operates on a capital-deployment model, where users invest digital assets (primarily USDT and other stablecoins), and our internal trading infrastructure actively manages and grows those assets through professional, algorithm-backed crypto trading strategies. Our users enjoy predictable, competitive returns without the need to trade, analyze markets, or understand blockchain intricacies.<br /><br />
            What differentiates TradeSpot is not just the investment service, but the ecosystem we’re building around it — a robust suite of tools, features, and protocols that elevate user trust, experience, and scalability:<br /><br />
            <span style={{ color: '#00bfff', fontWeight: 600 }}>✅ Biometric Security (SPOTID):</span> Every user is uniquely verified using facial recognition and liveness detection, eliminating impersonation, fraud, and unauthorized access.<br />
            <span style={{ color: '#00bfff', fontWeight: 600 }}>✅ TradeSpot Independent Authenticator:</span> A proprietary, secure login system replacing third-party logins, reinforcing platform sovereignty and user privacy.<br />
            <span style={{ color: '#00bfff', fontWeight: 600 }}>✅ Zero-Knowledge User Experience:</span> Investors require no prior trading knowledge. The entire process — from deposit to profit distribution — is fully automated, monitored, and managed by TradeSpot’s backend systems.<br />
            <span style={{ color: '#00bfff', fontWeight: 600 }}>✅ Transparency & Trust:</span> All trading activities, profit-sharing logs, and withdrawal approvals are available for user viewing through a secure admin-linked interface.<br />
            <span style={{ color: '#00bfff', fontWeight: 600 }}>✅ Native Asset (SpotCoin):</span> TradeSpot introduces SpotCoin, an internal digital token facilitating on-platform transactions, peer-to-peer transfers, and service payments with minimal fees and real-time processing.<br />
            <span style={{ color: '#00bfff', fontWeight: 600 }}>✅ Social Finance Hub:</span> Users can engage with public investment discussions, follow performance updates, and participate in a growing community-driven investment culture.<br />
            <span style={{ color: '#00bfff', fontWeight: 600 }}>✅ AI Automation – SuperAI Engine:</span> A proprietary AI bot that operates 24/7 to execute trades, assist user queries, monitor fraud indicators, and enforce platform rules in real-time.<br />
            <span style={{ color: '#00bfff', fontWeight: 600 }}>✅ Seamless Crypto Onboarding:</span> Users fund their accounts by transferring crypto directly to their personalized deposit addresses. Fiat onramps will be integrated in future releases to accommodate a global investor base.<br />
            <span style={{ color: '#00bfff', fontWeight: 600 }}>✅ Low-Fee, Fast Withdrawals:</span> Our hybrid withdrawal system leverages manual admin approval for added security while maintaining speed and efficiency — typically processing within hours, not days.<br />
            <span style={{ color: '#00bfff', fontWeight: 600 }}>✅ User-to-User Wallet Transfers:</span> A built-in internal transfer feature allows users to send funds instantly across TradeSpot accounts without leaving the platform.<br /><br />
            TradeSpot is more than an investment app — it is a secure digital wealth engine, a social-financial ecosystem, and a next-gen fintech platform built to meet the demands of both retail and institutional crypto investors in the 21st century.<br /><br />
            Our vision is simple yet ambitious:<br /><br />
            <span style={{ fontStyle: 'italic', color: '#003366' }}>&gt; To become the most trusted, accessible, and intelligent crypto investment infrastructure globally — where anyone, anywhere, can grow wealth passively, securely, and transparently.</span>
          </span>
        </div>
      </main>
      {!isApp() && showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.35)",
            zIndex: 20000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => setShowModal(false)}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 14,
              padding: 28,
              minWidth: 260,
              maxWidth: "90vw",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              position: "relative",
            }}
            onClick={e => e.stopPropagation()}
          >
            <button
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                top: 10,
                right: 14,
                background: "none",
                border: "none",
                fontSize: 22,
                color: "#888",
                cursor: "pointer",
              }}
              aria-label="Close"
            >
              &times;
            </button>
            <div style={{ fontWeight: 700, fontSize: 20, color: "#003366", marginBottom: 18 }}>
              Download TradeSpot App
            </div>
            <button
              onClick={handlePlaystore}
              style={{
                width: "100%",
                maxWidth: 260,
                margin: "8px 0",
                padding: "10px 0",
                background: "#34a853",
                color: "#fff",
                border: "none",
                borderRadius: 6,
                fontWeight: 600,
                fontSize: 16,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
              }}
            >
              <span style={{ fontSize: 20, marginRight: 8 }}>▶️</span> Download on Playstore
            </button>
          </div>
        </div>
      )}    </div>
  );
}

export default HomePage;